import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_VEHICLE, UPDATE_VEHICLE_SUCCESS, UPDATE_VEHICLE_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* updateVehicle({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/vehicles/${payload?.id}`,
      method: 'PUT',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_VEHICLE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_VEHICLE_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_VEHICLE_ERROR, payload: error });
  }
}

export function* watchUpdateVehicle() {
  yield takeEvery(UPDATE_VEHICLE, updateVehicle);
}

function* updateVehicleSaga() {
  yield all([fork(watchUpdateVehicle)]);
}

export default updateVehicleSaga;
